import { checkDocuments, documentCheckLoadingFlags } from "./actions";

const escapeHtml = value => String(value || "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");

export const documentCheck = {
    "label": "AI — Document Check",
    "key": "DocumentCheck",
    "local": true,
    "field": true,
    "fields": [{
        "label": "Report",
        "class": "md:col-span-3",
        "grow": true,
        compute({ item }) {
            return escapeHtml(item?.DocumentCheck?.Text).replaceAll("\n", "<br>");
        },
        get loading() {
            return function ({ item }) {
                return documentCheckLoadingFlags[item?.ID] || false;
            };
        }
    }, {
        "label": "Checked",
        "key": "DocumentCheck.Date.Created",
        "type": "date"
    }, {
        "label": "Model",
        "key": "DocumentCheck.Model"
    }, {
        "label": "Checked By",
        compute({ item }) {
            return escapeHtml(item?.DocumentCheck?.CreatedBy?.Email || item?.DocumentCheck?.CreatedBy?.UID || "");
        }
    }],
    "actions": [{
        "label": "AI - Check Documents",
        "action": checkDocuments
    }],
    "rowActions": []
};
